import * as React from 'react';
import * as classnames from 'classnames/bind';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {observer} from 'mobx-react';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';

const styles = require('./BuildVersion.less');
const cx = classnames.bind(styles);

@observer
export class BuildVersion extends React.Component<any, any>
{
    constructor(props:any)
    {
        super(props);
    }

    render()
    {
        let version = rootState.ui.version;

        if( !version )
            return null;

        return  <Column className={cx('buildVersion')}>
                    Build {version.isLocalDevMode?'LOCAL':version.number} {version.startTime?`@ ${version.startTime}`:''}
                </Column>;
    }
}
